export default __webpack_public_path__ + "static/media/piano.bf569c4d.png";